<template>
	<div class="d-flex flex-column align-items-center">
		<h4>{{ titulo }}</h4>
		<div class="d-flex justify-content-center align-items-center mt-2">
			<button class="btn btn-success mr-2" @click="$emit('sim')">Sim</button>
			<button class="btn btn-danger" @click="$emit('nao')">Não</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		titulo: {
			type: String,
			required: false,
			default: ''
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/modal-opcoes-sim-nao/main.vue